<template lang="pug">
nav.navbar.navbar-expand-lg.main-navbar
  form.form-inline
    ul.navbar-nav
      li
        a.nav-link.nav-link-lg(href='javascript:void(0)' data-toggle='sidebar')
          i.fas.fa-outdent
  ul.navbar-nav.navbar-right.ml-auto
    template(v-if="cpiEnable")
      //- li.dropdown(v-if="isAdminMaster && getCpiDetails == null")
      li.dropdown(v-if="showHideCpi()")
        .ml-2.btn.btn-info(:title='$t("ui.cpi_enrol")' @click="cpiEnrol()")
          span {{ $t("ui.cpi_enrol") }}
    li.dropdown(v-if="isOperator")
      span.font-weight-bold.alert.alert-primary.px-2.py-2 {{ getCurrencyCode }} {{ $n(operatorWallet, 'currency') }}
    li.dropdown.dropdown-list-toggle
      a.nav-link.notification-toggle.nav-link-lg(href="javascript:void(0)" @click="toTicketPage" v-if="showNotification" :class="{ 'beep': totalRow > 0}")
        i.far.fa-bell
        span.badge-sm.badge-pill.badge-info.ml-1(v-if="showNotification") {{ totalRow }}
    //- li.dropdown
    //-   a.nav-link.nav-link-lg.nav-link-user(href='javascript:void(0)' @click='showGuide = true')
    //-     i.far.fa-question-circle
    li.dropdown
      a.nav-link.nav-link-lg.nav-link-user(href='javascript:void(0)' data-toggle='dropdown')
        img.rounded-circle.mr-1(alt='image' :src="'/assets/img/flag/' + language + '.png?v=14'")
      .dropdown-menu.dropdown-menu-right
        a.dropdown-item(href="javascript:void(0)" v-for="item in languageList" @click="setLanguage(item)" :class="{ 'selected' : item == language }")
          img.rounded-circle.mr-1(alt='image' :src="'/assets/img/flag/' + item + '.png?v=13'")
          | {{ $t("language.list." + item) }}

  Alert(:alert="isPendingTix" :randomKey="randomKey" v-if="showNotification && isPendingTix && $store.getters.alertOn == true").mx-2

  //- #popup.popup-overlay(v-if="showGuide")
  //-   .popup-content
  //-     i.btn.btn-danger.fas.fa-times.close-icon(@click='showGuide = false')
  //-     img(:src="'/assets/img/guide_' + language + '.png'" alt='Popup Image' )


</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import Alert from '@/library/Alert';

export default {
  name: "App",
  components: {
    Alert,
  },
  data: function() {
    return {
      // languageList: ["en", "zh", "my", "id", "th", "vi"],
      languageList: ["en", "zh"],
      timerId: null,
      timerBalance: null,
      timerSecurityDeposit: null,
      refreshTime: 5,
      refreshOpBalanceTime: 60,
      refreshOpSecurityDepositTime: 60,
      refreshUpdate: "",
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      pendingTicket: false,
      totalRow: 0,
      alertKey: '',
      subDetail: null,
      // showGuide: false,
      channel: "",
      operatorWallet: 0
    };
  },
  computed: {
    serverName() {
      return config.serverName;
    },
    // baseCurrency() {
    //   return config.currency;
    // },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    },
    isOperator() {
      return this.$store.getters.accountType === 2;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    language() {
      return this.$store.getters.language;
    },
    randomKey() {
      return this.alertKey;
    },
    isPendingTix() {
      return this.pendingTicket;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
    showNotification() {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.subDetail && this.subDetail.authority_option) {
          var roles =  this.subDetail.authority_option && this.subDetail.authority_option.length > 0 ? this.subDetail.authority_option.split(',') : []; // newly added
          if (roles.includes('pendingticket'))
            return true;
          else
            return false;
        } else
          return false;
      }

      return true;
    },
    defaultLink() {
      if (this.$store.getters.account[0] && this.$store.getters.authorityRole) {
        if (this.$store.getters.authorityRole != 'SUB_PRI') {
          if (config.superUser == this.$store.getters.accountId)
            return "/account/operator";
          else
            return "/account/memberList";
        } else
          return '/system/setting';
      }

      return '/system/dashboard';
    },
    isShown() {
      return this.$store.getters.isShown;
    },
    getCpiDetails() {
      return this.$store.getters.cpiDetails;
    },
    cpiEnable() {
      return config.cpiEnable == "1";
    }
  },
  created: function() {
    this.$options.refreshEnabled = true;
  },
  mounted() {
    // if(!this.isShown) {
    //   this.showGuide = true
    //   this.$store.dispatch("user/setGuide", true);
    // }
    if(this.$store.getters.sessionToken) {
      this.initializeJQueryFunctions();
      this.getInfo();
      this.startCountDownRefresh();

      if(this.isOperator) {
        this.startCountDownRefreshBalance();
      }

      var appLang = config.appLang
      if(appLang != null) {
        var splitLang = appLang.split(',')
        for(var i = 0; i < splitLang.length; i++) {
          this.languageList.push(splitLang[i])
        }
      }
    } else {
      this.$helpers.handleFeedback('NoUserAccessRight');
    }
  },
  destroyed: function() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
    if (this.timerBalance) {
      clearTimeout(this.timerBalance);
    }
    if (this.timerSecurityDeposit) {
      clearTimeout(this.timerSecurityDeposit);
    }
  },
  methods: {
    showHideCpi() {
      if (this.getCpiDetails != null || ['MYR'].includes(this.getCurrencyCode) || !this.isOperator) return false

      return true
      // return ['MYR'].includes(this.getCurrencyCode)
      //   ? this.isAdminMaster
      //   : this.isOperator
    },
    initializeJQueryFunctions() {
      // console.log("Initializing")
      let sidebar_nicescroll_opts = {
        cursoropacitymin: 0,
        cursoropacitymax: 0.8,
        zindex: 892,
      };
      let now_layout_class = null;

      const sidebar_sticky = () => {
        if ($('body').hasClass('layout-2')) {
          $('#sidebar-wrapper').stick_in_parent({
            parent: $('body'),
          });
          $('#sidebar-wrapper').stick_in_parent({ recalc_every: 1 });
        }
      };
      sidebar_sticky();

      let sidebar_nicescroll;
      const update_sidebar_nicescroll = () => {
        let a = setInterval(() => {
          if (sidebar_nicescroll != null) sidebar_nicescroll.resize();
        }, 10);

        setTimeout(() => {
          clearInterval(a);
        }, 600);
      };

      const sidebar_dropdown = () => {
        if ($('.main-sidebar').length) {
          $('.main-sidebar').niceScroll(sidebar_nicescroll_opts);
          sidebar_nicescroll = $('.main-sidebar').getNiceScroll();

          $('.main-sidebar .sidebar-menu li a.has-dropdown').off('click').on('click', function () {
            const me = $(this);

            if (!$('body').hasClass('sidebar-mini')) {  // Prevent from staying when on click parent dropdown if is minimized
              me.parent().toggleClass('show');
              me.parent().find('> .dropdown-menu').slideToggle(500, () => {
                update_sidebar_nicescroll();
                return false;
              });
            }
            return false;
          });
        }
      };
      sidebar_dropdown();

      if ($('#top-5-scroll').length) {
        $('#top-5-scroll').css({
          height: 315,
        }).niceScroll();
      }

      $('.main-content').css({
        minHeight: $(window).outerHeight() - 95,
      });

      $('.nav-collapse-toggle').click(function () {
        $(this).parent().find('.navbar-nav').toggleClass('show');
        return false;
      });

      $(document).on('click', function () {
        $('.nav-collapse .navbar-nav').removeClass('show');
      });

      const toggle_sidebar_mini = (mini) => {
        const body = $('body');

        if (!mini) {
          body.removeClass('sidebar-mini');
          $('.main-sidebar').css({
            overflow: 'hidden',
          });
          setTimeout(() => {
            $('.main-sidebar').niceScroll(sidebar_nicescroll_opts);
            sidebar_nicescroll = $('.main-sidebar').getNiceScroll();
          }, 500);
          $('.main-sidebar .sidebar-menu > li > ul .dropdown-title').remove();
          $('.main-sidebar .sidebar-menu > li > a').removeAttr('data-toggle');
          $('.main-sidebar .sidebar-menu > li > a').removeAttr('data-original-title');
          $('.main-sidebar .sidebar-menu > li > a').removeAttr('title');

          // Open Dropdown parent when there is active child menu (during minimized to maximized)
          let cssList = document.querySelectorAll('li.dropdown-menu-item.active');
          for(var i = 0; i < cssList.length; i++) {
            cssList[i].parentElement.style.display = "block";
          }
        } else {
          body.addClass('sidebar-mini');
          body.removeClass('sidebar-show');
          if (sidebar_nicescroll) {
            sidebar_nicescroll.remove();
            sidebar_nicescroll = null;
          }

          // Prevent stay display after click child menu (during maximized to minimized)
          this.$helpers.hideChildMenu();
          // $('.main-sidebar .sidebar-menu > li').each(function () {
          //   const me = $(this);

          //   if (me.find('> .dropdown-menu').length) {
          //     me.find('> .dropdown-menu').hide();
          //     me.find('> .dropdown-menu').prepend(`<li class="dropdown-title pt-3">${me.find('> a').text()}</li>`);
          //   } else {
          //     me.find('> a').attr('data-toggle', 'tooltip');
          //     me.find('> a').attr('data-original-title', me.find('> a').text());
          //     $('[data-toggle="tooltip"]').tooltip({
          //       placement: 'right',
          //     });
          //   }
          // });
        }
      };

      $('[data-toggle="sidebar"]').click(function () {
        const body = $('body');
        const w = $(window);

        if (w.outerWidth() <= 1024) {
          body.removeClass('search-show search-gone');
          if (body.hasClass('sidebar-gone')) {
            body.removeClass('sidebar-gone');
            body.addClass('sidebar-show');
          } else {
            body.addClass('sidebar-gone');
            body.removeClass('sidebar-show');
          }

          update_sidebar_nicescroll();
        } else {
          body.removeClass('search-show search-gone');
          if (body.hasClass('sidebar-mini')) {
            toggle_sidebar_mini(false);
          } else {
            toggle_sidebar_mini(true);
          }
        }

        return false;
      });

      const toggleLayout = () => {
        const w = $(window);
        const layout_class = $('body').attr('class') || '';
        const layout_classes = layout_class.trim().length > 0 ? layout_class.split(' ') : '';

        if (layout_classes.length > 0) {
          layout_classes.forEach((item) => {
            if (item.indexOf('layout-') !== -1) {
              now_layout_class = item;
            }
          });

          if (!$('body').hasClass('sidebar-mini')) {  // Prevent stay display if child menu is active in minimized mode
            let cssList = document.querySelectorAll('li.dropdown-menu-item.active');
            for(var i = 0; i < cssList.length; i++) {
              cssList[i].parentElement.style.display = "block";
            }
          }
        }

        if (w.outerWidth() <= 1024) {
          if ($('body').hasClass('sidebar-mini')) {
            toggle_sidebar_mini(false);
            $('.main-sidebar').niceScroll(sidebar_nicescroll_opts);
            sidebar_nicescroll = $('.main-sidebar').getNiceScroll();
          }

          $('body').addClass('sidebar-gone');
          $('body').removeClass('layout-2 layout-3 sidebar-mini sidebar-show');
          $('body').off('click').on('click', (e) => {
            if ($(e.target).hasClass('sidebar-show') || $(e.target).hasClass('search-show')) {
              $('body').removeClass('sidebar-show');
              $('body').addClass('sidebar-gone');
              $('body').removeClass('search-show');

              update_sidebar_nicescroll();
            }
          });

          update_sidebar_nicescroll();

          if (now_layout_class === 'layout-3') {
            const nav_second_classes = $('.navbar-secondary').attr('class');
            const nav_second = $('.navbar-secondary');

            nav_second.attr('data-nav-classes', nav_second_classes);
            nav_second.removeAttr('class');
            nav_second.addClass('main-sidebar');

            const main_sidebar = $('.main-sidebar');
            main_sidebar.find('.container').addClass('sidebar-wrapper').removeClass('container');
            main_sidebar.find('.navbar-nav').addClass('sidebar-menu').removeClass('navbar-nav');
            main_sidebar.find('.sidebar-menu .nav-item.dropdown.show a').click();
            main_sidebar.find('.sidebar-brand').remove();
            main_sidebar.find('.sidebar-menu').before(
              $('<div>', {
                class: 'sidebar-brand',
              }).append(
                $('<a>', {
                  href: $('.navbar-brand').attr('href'),
                }).html($('.navbar-brand').html())
              )
            );
            setTimeout(() => {
              sidebar_nicescroll = main_sidebar.niceScroll(sidebar_nicescroll_opts);
              sidebar_nicescroll = main_sidebar.getNiceScroll();
            }, 700);

            sidebar_dropdown();
            $('.main-wrapper').removeClass('container');
          }
        } else {
          $('body').removeClass('sidebar-gone sidebar-show');
          if (now_layout_class) $('body').addClass(now_layout_class);

          const nav_second_classes = $('.main-sidebar').attr('data-nav-classes');
          const nav_second = $('.main-sidebar');

          if (now_layout_class === 'layout-3' && nav_second.hasClass('main-sidebar')) {
            nav_second.find('.sidebar-menu li a.has-dropdown').off('click');
            nav_second.find('.sidebar-brand').remove();
            nav_second.removeAttr('class');
            nav_second.addClass(nav_second_classes);

            const main_sidebar = $('.navbar-secondary');
            main_sidebar.find('.sidebar-wrapper').addClass('container').removeClass('sidebar-wrapper');
            main_sidebar.find('.sidebar-menu').addClass('navbar-nav').removeClass('sidebar-menu');
            main_sidebar.find('.dropdown-menu').hide();
            main_sidebar.removeAttr('style');
            main_sidebar.removeAttr('tabindex');
            main_sidebar.removeAttr('data-nav-classes');
            $('.main-wrapper').addClass('container');
          } else if (now_layout_class === 'layout-2') {
            $('body').addClass('layout-2');
          } else {
            update_sidebar_nicescroll();
          }
        }
      };
      toggleLayout();
      $(window).resize(toggleLayout);
    },
    setLanguage(lang) {
      this.$store.dispatch("layout/setLanguage", lang);
    },
    getInfo() {
      if (this.getAuthorityRole == 'SUB_PRI') {
        this.getSubDetail();
      }
    },
    getSubDetail() {
      let url = config.accountSubDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        login_id: this.$store.getters.loginId
      };

      this.$http.post(url, json).then(
        function(response) {
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.subDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    forceRerenderAlert: function() {
      this.alertKey = Math.random().toString(36).replace('0.', '');
    },
    toTicketPage: function() {
      if (this.$router.history.current.path != '/ticket/pendingTicket') {
        var json = { tab: 1 };
        this.$store.dispatch("user/setPendingTicketParam", json);

        if(!this.isOperator) {
          this.$router.push("/ticket/pendingTicket");
        } else {
          this.$router.push("/ticketoperator/ticketListOp");
        }
      }
    },
    startCountDownRefresh: function() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      if (this.$options.refreshEnabled) {
        this.getTicketList();
        this.timerId = setTimeout(() => {
          this.startCountDownRefresh();

          if (this.showNotification == true) {
            if (this.totalRow > 0) {
              this.pendingTicket = true;
              this.forceRerenderAlert();
            } else {
              this.pendingTicket = false;
            }
          }
        }, this.refreshTime * 1000);
      }
    },
    startCountDownRefreshBalance: function() {
      if (this.timerBalance) {
        clearTimeout(this.timerBalance);
      }
      if (this.$options.refreshEnabled) {
        this.getOperatorWalletBalance();

        this.timerBalance = setTimeout(() => {
          this.startCountDownRefreshBalance();
        }, this.refreshOpBalanceTime * 1000);
      }
    },
    getTicketList: function() {
      if (this.showNotification == true) {
        this.getTicketListPendingCount();
      } else {
        this.totalRow = 0;
        this.pendingTicket = false;
      }
    },
    getTicketListPendingCount: function() {
      let url = config.ticketListPendingCountUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.totalRow = response.data.dt.length > 0 ? response.data.dt[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) {
                  this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getOperatorWalletBalance: function() {
      let url = config.operatorWalletBalanceUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.operatorWallet = response.data.dt.length > 0 ? response.data.dt[0].cash_balance : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) {
                  this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    cpiEnrol: function() {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.cpi_enrol_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmCpiEnrol();
          }
        });
    },
    confirmCpiEnrol: function() {
      // config.cpiEnrolUrl();
      let url = config.cpiEnrolUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.cpi_enrol"), this.$t("message.success"), "success");
                this.$store.dispatch("user/setCpiDetails", true);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>

